// Обрезка подписей цитат — общий рецепт для всех трёх поверхностей с чипами
// источников: чат репетитора (`tutor/chat/rendered-markdown`), конспект
// (`notes/editor/note-citation-group`) и транскрипт аудио-резюме
// (`audio-recaps/script-citations`).
//
// Вынесено сюда, потому что три параллельные копии одной функции с одной и той
// же константой 22 уже начали расходиться: чип обязан выглядеть одинаково во
// всех трёх местах, иначе один и тот же материал подписан по-разному.
//
// Группировку подряд идущих цитат делает `@/lib/citation-runs` (чат и
// транскрипт) либо `notes/editor/note-citation-runs` (конспект — там позиции
// ProseMirror и диапазоны покрытия, а не индексы блоков).

/** Потолок подписи чипа: в строке текста он обязан оставаться короче фразы. */
export const CHIP_LABEL_MAX = 22;

/** Сколько текста фрагмента показываем в строке поповера. */
export const CITATION_SNIPPET_MAX = 300;

/** `«Лекция 12. Термодинамика газов»` → `«Лекция 12. Термоди…»`. */
export function truncateChipLabel(label: string, max = CHIP_LABEL_MAX): string {
	const trimmed = label.trim();
	if (trimmed.length <= max) return trimmed;
	return `${trimmed.slice(0, max - 1).trimEnd()}…`;
}

/** Превью фрагмента в строке поповера — тот же потолок во всех поверхностях. */
export function truncateCitationSnippet(text: string, max = CITATION_SNIPPET_MAX): string {
	const trimmed = text.trim();
	if (trimmed.length <= max) return trimmed;
	return `${trimmed.slice(0, max).trimEnd()}…`;
}
